module.exports = __webpack_public_path__ + "assets/img/logo-wire-transfers.62f6aa35.svg";